import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { ArrowLeft, ExternalLink, Calendar } from "lucide-react";
import api from "@/lib/api";
import { DataTag, Disclaimer } from "@/components/common";

export default function LegislationDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState(null);

    useEffect(() => { api.get(`/legislation/${id}`).then((r) => setData(r.data)).catch(() => {}); }, [id]);

    if (!data) return null;
    const l = data.legislation;

    return (
        <div className="max-w-3xl mx-auto space-y-6" data-testid="legislation-detail-page">
            <button onClick={() => navigate("/legislacao")} className="text-sm text-slate-500 hover:text-petroleum flex items-center gap-1"><ArrowLeft className="w-4 h-4" /> Legislação</button>

            <div className="bg-white border border-slate-200 rounded-md p-6 shadow-sm">
                <div className="flex items-center gap-2">
                    <span className="text-[11px] px-2 py-0.5 rounded-full bg-petroleum/10 text-petroleum border border-petroleum/20 font-semibold">{l.type}</span>
                    <DataTag kind="oficial" />
                    <span className="text-[11px] px-2 py-0.5 rounded-full bg-green-50 text-green-700 border border-green-200">{l.status}</span>
                </div>
                <h1 className="mt-4 font-heading text-2xl font-black text-slate-900 leading-tight">{l.title}</h1>
                <div className="mt-3 flex flex-wrap gap-4 text-xs text-slate-500">
                    <span>Número: <b className="text-slate-700">{l.number || "—"}</b></span>
                    <span>Tema: <b className="text-slate-700">{l.theme}</b></span>
                    <span className="inline-flex items-center gap-1"><Calendar className="w-3 h-3" /> Verificado em: {l.verification_date}</span>
                </div>

                <section className="mt-6">
                    <h2 className="font-heading font-bold text-slate-800">Resumo</h2>
                    <p className="mt-2 text-slate-600 leading-relaxed">{l.summary}</p>
                </section>
                {l.application && (
                    <section className="mt-5">
                        <h2 className="font-heading font-bold text-slate-800">Aplicação prática</h2>
                        <p className="mt-2 text-slate-600 leading-relaxed">{l.application}</p>
                    </section>
                )}
                {l.text && (
                    <section className="mt-5">
                        <h2 className="font-heading font-bold text-slate-800">Texto / indexação</h2>
                        <p className="mt-2 text-slate-600 leading-relaxed whitespace-pre-wrap">{l.text}</p>
                    </section>
                )}

                <div className="mt-6 p-4 bg-slate-50 border border-slate-200 rounded-md">
                    <div className="text-[11px] font-bold uppercase tracking-wide text-slate-500 mb-1">Fonte oficial</div>
                    <div className="text-sm text-slate-700">{l.source}</div>
                    <a href={l.url} target="_blank" rel="noreferrer" data-testid="legislation-official-link" className="mt-2 inline-flex items-center gap-1 text-petroleum hover:text-petroleumHover font-semibold text-sm"><ExternalLink className="w-4 h-4" /> Abrir norma na fonte oficial</a>
                </div>
            </div>

            {data.related?.length > 0 && (
                <div>
                    <h2 className="font-heading font-bold text-slate-800 mb-3">Assuntos relacionados</h2>
                    <div className="space-y-2">
                        {data.related.map((r) => (
                            <Link key={r.id} to={`/legislacao/${r.id}`} className="block bg-white border border-slate-200 rounded-md p-3 text-sm hover:border-petroleum/30 transition-colors">
                                <span className="font-semibold text-slate-800">{r.title}</span>
                            </Link>
                        ))}
                    </div>
                </div>
            )}
            <Disclaimer />
        </div>
    );
}
